import { gql } from '@apollo/client';

export const METADATA_QUERY = gql`
  query MetadataQuery {
    metadata {
      isMock
    }
  }
`;
